/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2022 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
import { getUint8Array } from "@keeex/js-utils/lib/uint8array.js";
import { browserNameFromAlgorithmName } from "../digest/browser.js";
const hmacKeyFromBuf8 = (key, algorithm) => {
  const browserAlgo = browserNameFromAlgorithmName(algorithm);
  return crypto.subtle.importKey("raw", key, {
    name: "HMAC",
    hash: browserAlgo
  }, false, ["sign"]);
};
const hmacImmediate = async (algorithm, data, key) => {
  const hmacKey = await hmacKeyFromBuf8(key, algorithm);
  const res = await crypto.subtle.sign("HMAC", hmacKey, data);
  return getUint8Array(res);
};
const hmacProvider = {
  hmacImmediate
};
export default hmacProvider;
